import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { BusinessFinancialDetailsForm } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessFinancialDetails/components/BusinessFinancialDetailsForm';
import {
  BusinessFinancialDetailsFormSchema,
  BusinessFinancialDetailsFormType,
} from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessFinancialDetails/schemas/BusinessFinancialDetailsFormSchema';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { removeNullKeysFromObject } from '@/utils/removeNullKeysFromObject';

interface BusinessFinancialDetailsEditDialogProps {
  businessDetails: BusinessOnboardingDetails;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
  setBusinessDetailsToOnboardingDetails: (data) => void;
  loading?: boolean;
}

export const BusinessFinancialDetailsEditDialog = ({
  businessDetails,
  opened,
  setOpened,
  toggleDialog,
  setBusinessDetailsToOnboardingDetails,
  loading,
}: BusinessFinancialDetailsEditDialogProps) => {
  const businessDetailsValues = businessDetails.businessDetails;

  const businessFinancialDetailsDefaultValues = {
    capitalStock: businessDetailsValues?.financialDetails.capitalStock.amount.toString() ?? null,
    ownFunds: businessDetailsValues?.financialDetails.ownFunds?.amount.toString() ?? null,
    taxBase: businessDetailsValues?.financialDetails.taxBase?.amount.toString() ?? null,
    individualFinancialNetAmount:
      businessDetailsValues?.financialDetails.individualFinancialNetAmount?.amount.toString() ?? null,
  };

  const onSubmitForm = async (formValues: BusinessFinancialDetailsFormType) => {
    if (!businessDetailsValues) return;
    const currency = businessDetailsValues.financialDetails.capitalStock.currency;
    const onboardingDetails = {
      ...businessDetailsValues,
      id: businessDetails.id,
      address: { ...businessDetailsValues.address, formatted: businessDetailsValues.address.formattedAddress },
      financialDetails: {
        ...businessDetailsValues.financialDetails,
        capitalStock: formValues.capitalStock && {
          amount: Number(formValues.capitalStock),
          currency,
        },
        ownFunds: formValues.ownFunds && { amount: Number(formValues.ownFunds), currency },
        taxBase: formValues.taxBase && { amount: Number(formValues.taxBase), currency },
        individualFinancialNetAmount: formValues.individualFinancialNetAmount && {
          amount: Number(formValues.individualFinancialNetAmount),
          currency,
        },
      },
    };
    await setBusinessDetailsToOnboardingDetails(removeNullKeysFromObject(onboardingDetails));
    toggleDialog();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'EDIT_BUSINESS_FINANCIAL_DETAILS'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      formSchema={BusinessFinancialDetailsFormSchema}
      defaultValues={businessFinancialDetailsDefaultValues}
    >
      <BusinessFinancialDetailsForm
        businessDetails={businessDetails.businessDetails}
        fullWidth
        fieldVariant={FieldVariant.form}
      />
    </EditDialogWrapper>
  );
};
